import Tooltip from '@creditflowresearch/uilib/Tooltip';
import { formatUpdatedAt } from '@/creditflowresearch/ui/components/ActiveCalendar/helpers/dates';
import { EMPTY_CELL_STATE } from '@/creditflowresearch/ui/common/constants';
import { ITimezone } from '@framework/timezone/vo/Timezone';

interface IUpdatedAtCellProps {
  value: string | null | undefined,
  timeZone?: ITimezone,
}

const UpdatedAtCell = ({ value, timeZone }: IUpdatedAtCellProps) => {
  if (!value || isNaN(Date.parse(value))) {
    return <>{ EMPTY_CELL_STATE }</>;
  }

  const { short, full } = formatUpdatedAt(value, timeZone);

  return (
    <Tooltip content={ full }>
      <span>{ short }</span>
    </Tooltip>
  );
};

export default UpdatedAtCell;
